import classNames from "classnames";
import "./style.scss";
import { getCompoundStyle } from "../helpers";
import { useRef } from "react";
import { BuilderComponentProps } from "../BuilderInterface";

const BuilderGlobalBlockPrint: React.FC<BuilderComponentProps> = ({
    node,
    children,
    actionCallbacks,
    builderProps
}: BuilderComponentProps) => {
    const { id, attr } = node;
    const div = useRef<HTMLDivElement>(null);

    const builderGlobalBlockPrintClass = classNames("builder-global-block-print", {
        [`${attr?.className}`]: !!attr?.className
    });

    if (builderProps) {
        const { selectedMenu, selectCallback, outlineCallback, onDragStart, onDragEnd, onDragOverCapture } = builderProps;

        return (
            <div
                {...attr}
                ref={div}
                className={builderGlobalBlockPrintClass}
                style={getCompoundStyle({ node })}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                id={id}
                onDragStart={e => onDragStart?.(e, id)}
                onDragOverCapture={e => onDragOverCapture?.(e, id, div.current as HTMLDivElement)}
                draggable={"true"}
                onDragEnd={onDragEnd}
            >
                {children}
                {selectedMenu}
            </div>
        );
    } else {
        return (
            <div {...attr} {...actionCallbacks} className={builderGlobalBlockPrintClass} style={getCompoundStyle({ node })}>
                {children}
            </div>
        );
    }
};

export default BuilderGlobalBlockPrint;
